/* claude new 2026-10-16: idioma del checkout.
   La app "CR Store Pickup & Delivery" reescribe el formulario del carrito con "?locale=en&step=contact_information",
   asi que los pedidos salian en ingles (emails, Shop, idioma del cliente). Aqui se pone el idioma real de la tienda
   (window.nbLocale = request.locale.iso_code) justo antes de enviar el formulario. No toca nada mas. */
(function () {
  var L = window.nbLocale || document.documentElement.lang || '';
  if (!L) return;
  function fix(f) {
    if (!f || f.tagName !== 'FORM') return;
    var a = f.getAttribute('action') || '', b = a;
    if (/[?&]locale=/i.test(a)) b = a.replace(/([?&])locale=[^&]*/i, '$1locale=' + encodeURIComponent(L));
    // Retrait en magasin : l'app envoie vers "/checkout?..." sans langue -> checkout en français. On ajoute la langue.
    else if (/(^|\/)(checkout|cart)(\?|$)/.test(a.replace(/^https?:\/\/[^/]+/, '').split('#')[0].replace(/\?.*$/, '?'))) b = a + (a.indexOf('?') > -1 ? '&' : '?') + 'locale=' + encodeURIComponent(L);
    if (b !== a) f.setAttribute('action', b);
  }
  function fixAll() { document.querySelectorAll('form[action*="locale="], form[action*="checkout"]').forEach(fix); }
  document.addEventListener('submit', function (e) { fix(e.target); }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[name="checkout"], [type="submit"]');
    if (b) fix(b.form || b.closest('form'));
  }, true);
  document.addEventListener('crButtonsLoaded', function () { setTimeout(fixAll, 0); });
  if (document.readyState !== 'loading') fixAll(); else document.addEventListener('DOMContentLoaded', fixAll);
})();
